import { QUERY_PARAMS } from "../constants/storage.constants";
import { STORAGE } from "../data/enums/storage";
import { isBrowser } from "./dom";

export const localStorageConstants = {
  AUTH_TOKEN: "microserviceAuthToken",
};

export function getLocalSetting(key: string) {
  if (
    typeof Storage !== "undefined" &&
    typeof localStorage !== "undefined" &&
    localStorage !== null &&
    localStorage.getItem(key) !== null
  ) {
    return localStorage.getItem(key);
  }

  return "";
}

export const storageAvailable = (type: STORAGE) => {
  var storage;
  try {
    storage = window[type];
    var x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    // return (
    //     e instanceof DOMException &&
    //     // everything except Firefox
    //     (e.code === 22 ||
    //         // Firefox
    //         e.code === 1014 ||
    //         // test name field too, because code might not be present
    //         // everything except Firefox
    //         e.name === 'QuotaExceededError' ||
    //         // Firefox
    //         e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
    //     // acknowledge QuotaExceededError only if there's something already stored
    //     storage &&
    //     storage.length !== 0
    // );
  }
};

export const getFromLocal = (
  key: string
): { [key: string]: string } | null | string => {
  if (isBrowser && storageAvailable(STORAGE.LOCAL_STORAGE)) {
    const item = window.localStorage ? window.localStorage.getItem(key) : null;
    return item && JSON.parse(item);
  }
  return null;
};

export const setLocal = (
  key: string,
  val: { [key: string]: string } | boolean | string
): void => {
  if (isBrowser && storageAvailable(STORAGE.LOCAL_STORAGE))
    window.localStorage.setItem(key, JSON.stringify(val));
};

export const setSession = (
  key: string,
  val: { [key: string]: string } | boolean | string
): void => {
  if (isBrowser && storageAvailable(STORAGE.SESSION_STORAGE))
    window.sessionStorage.setItem(key, JSON.stringify(val));
};

export const appendQueryParamsToLocalStorage = (params: {
  [key: string]: any;
}) => {
  
  const existingParams = getFromLocal(QUERY_PARAMS);
  if (existingParams && typeof existingParams === "object") {
    setLocal(QUERY_PARAMS, { ...existingParams, ...params });
  } else {
    setLocal(QUERY_PARAMS, { ...params });
  }
};

export const extractOnboardingParamsFromLocalstorage = () => {
  let destination;
  let skipOnboarding = false;

  let params = getFromLocal(QUERY_PARAMS) as {
    [key: string]: string;
  };

  if (params && params.hasOwnProperty("destination")) {
    destination = params?.destination;
  }
  if (params && params.hasOwnProperty("skipOnboarding")) {
    skipOnboarding = Boolean(params?.skipOnboarding);
  }
  return { destination, skipOnboarding };
};

export const clearFromLocal = (
  key: string
): { [key: string]: string } | null | string => {
  if (isBrowser && storageAvailable(STORAGE.LOCAL_STORAGE)) {
    const item = window.localStorage ? window.localStorage.getItem(key) : null;
    if (item) {
      localStorage.removeItem(key);
    }
  }
  return null;
};

export const getFromSessionStorage = (
  key: string
): { [key: string]: string } | null | string => {
  if (isBrowser && storageAvailable(STORAGE.SESSION_STORAGE)) {
    const item = window.sessionStorage
      ? window.sessionStorage.getItem(key)
      : null;
    return item && JSON.parse(item);
  }
  return null;
};

export const getLocalStorage = () => {
  try {
    if (isBrowser) {
      return window.localStorage;
    } else {
      throw Error("window is not defined");
    }
  } catch (error) {
    // if(console) {
    //   // console.error(error);
    // }
    return null;
  }
};
